'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var FacebookAppIcon = function FacebookAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    version: "1.1",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 382.4 376.4"
  }), React__default["default"].createElement("ellipse", {
    id: "XMLID_2_",
    fill: "#295396",
    cx: "191.2",
    cy: "188.2",
    rx: "189.2",
    ry: "189.2"
  }), React__default["default"].createElement("path", {
    id: "XMLID_1_",
    fill: "#FFFFFF",
    d: "M161.5,245.3c0-17.7-0.1-35.4,0.1-53.1c0-3-0.8-3.9-3.8-3.8c-5.5,0.2-11,0-16.6,0.1\n\t\tc-2.2,0.1-3.1-0.6-3-2.9c0.1-11,0.1-22.1,0-33.1c0-2.1,0.6-2.8,2.8-2.8c5.6,0.1,11.3-0.2,16.9,0.1c3.3,0.2,3.9-1,3.9-4\n\t\tc-0.2-8.4-0.2-16.8,0-25.2c0.2-10.3,3-19.9,9.1-28.2c7.7-10.6,18.7-15.4,31.4-16c13-0.6,26.1-0.3,39.2-0.4c1.8,0,2.4,0.6,2.4,2.4\n\t\tc-0.1,11.2-0.1,22.3,0,33.5c0,2-0.6,2.6-2.6,2.6c-6.3-0.1-12.6,0-18.8,0c-8.4,0-13.4,4.3-13.9,12.6c-0.4,6.6-0.1,13.3-0.3,20\n\t\tc-0.1,2.4,1.4,2.2,2.9,2.2c9.5,0,19.1,0.1,28.6-0.1c2.8,0,3.7,0.6,3.4,3.5c-1.2,11.1-2.2,22.2-3.2,33.4c-0.2,2.5-1.4,3-3.6,3\n\t\tc-7.5-0.1-15.1-0.1-22.6,0c-5.4,0-4.9-0.8-4.9,4.7c0,34.7-0.1,69.3,0.1,104c0,3.7-0.9,4.6-4.5,4.5c-12.9-0.2-25.9-0.2-38.8,0\n\t\tc-3.6,0.1-4.2-1.2-4.2-4.4C161.6,280.2,161.5,262.7,161.5,245.3z"
  }));
};

var FacebookAppIcon$1 = iconStyles()(FacebookAppIcon);

module.exports = FacebookAppIcon$1;
